import classNames from 'classnames/bind';
import React from 'react';
import { useStore } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import styles from './LogoutForce.module.scss';

import ModalWrapper from '@/components/ui/ModalWrapper';
import { ModalService as modal } from '@/libs/Modal';

const cx = classNames.bind(styles);

const Modal = ({ data }) => {
  const navigate = useNavigate();
  const store = useStore();

  const doOK = () => {
    navigate('/', { replace: true });

    // 리듀서 상태 초기화
    store.resetAll();

    modal.hide();
  };

  return (
    <ModalWrapper disableEscape className={cx('container')}>
      <div className={cx('message')}>
        A new login has been detected.
        <br />
        Your session will be terminated.
      </div>
      <div className={cx('wrapper')}>
        <div className={cx('info')}>IP Address : {data?.ip}</div>
      </div>
      <button type="button" className={cx(['button', 'accent'])} onClick={doOK}>
        OK
      </button>
    </ModalWrapper>
  );
};

export default Modal;
